export default function FM4MForm({
  category,
  setCategory,
  smiles,
  setSmiles,
  model,
  setModel,
  returnMode,
  setReturnMode,
  maxItemsInline,
  setMaxItemsInline,
  chunkSize,
  setChunkSize,
  errors = {},
}) {
  const onFile = async (e) => {
    const f = e.target.files && e.target.files[0];
    if (!f) return;
    const text = await f.text();
    const lines = text.split(/\r?\n|,/).map((s) => s.trim()).filter(Boolean);
    const merged = [smiles, lines.join('\n')].filter(Boolean).join('\n');
    setSmiles(merged);
  };
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <select value={model} onChange={(e) => setModel(e.target.value)}>
        <option value="mol-xl">mol-xl</option>
        <option value="smi-ted">smi-ted</option>
        <option value="bart">bart</option>
        <option value="pos">pos</option>
        <option value="mhg">mhg</option>
        <option value="Mordred">Mordred</option>
        <option value="MorganFingerprint">MorganFingerprint</option>
      </select>
      <select value={category} onChange={(e) => setCategory(e.target.value)}>
        <option value="small_molecule">small_molecule</option>
        <option value="polymer">polymer</option>
      </select>
      <div style={{ display: 'flex', gap: 8 }}>
        <label>
          <span>Return:</span>
          <select value={returnMode} onChange={(e) => setReturnMode(e.target.value)}>
            <option value="file">file</option>
            <option value="inline">inline</option>
          </select>
        </label>
        {returnMode === 'inline' && (
          <input type="number" value={maxItemsInline} onChange={(e) => setMaxItemsInline(e.target.value)} placeholder="max items inline" style={{ borderColor: errors.maxItemsInline ? '#ff6b6b' : undefined }} />
        )}
        <input type="number" value={chunkSize} onChange={(e) => setChunkSize(e.target.value)} placeholder="chunk size" style={{ borderColor: errors.chunkSize ? '#ff6b6b' : undefined }} />
      </div>
      <textarea value={smiles} onChange={(e) => setSmiles(e.target.value)} placeholder="SMILES (comma or newline separated)" rows={4} style={{ borderColor: errors.smiles ? '#ff6b6b' : undefined }} />
      {errors.smiles && <div style={{ color: '#ff6b6b', fontSize: 12 }}>{errors.smiles}</div>}
      {errors.maxItemsInline && <div style={{ color: '#ff6b6b', fontSize: 12 }}>{errors.maxItemsInline}</div>}
      {errors.chunkSize && <div style={{ color: '#ff6b6b', fontSize: 12 }}>{errors.chunkSize}</div>}
      <input type="file" accept=".txt,.csv" onChange={onFile} />
    </div>
  );
}
